import { alertAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'
import { mode } from '@chakra-ui/theme-tools'
import { textStyles } from '../foundations/textStyles'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(alertAnatomy.keys)

const baseStyleContainer = defineStyle(props => {
  const { colorScheme } = props

  return {
    bg: `${colorScheme}.100`,
    borderRadius: `xl`,
    borderWidth: `1px`,
    borderStyle: `solid`,
    borderColor: `${colorScheme}.400`,
    boxShadow: `base`,
  }
})

const baseStyleTitle = defineStyle(props => {
  const { colorScheme } = props

  return {
    color: mode(`${colorScheme}.900`, `white`)(props),
    ...textStyles['md'],
    fontWeight: `semibold`,
  }
})

const baseStyleDescription = defineStyle(props => {
  const { colorScheme } = props

  return {
    color: mode(`${colorScheme}.900`, `white`)(props),
    ...textStyles['md'],
  }
})

const baseStyleIcon = defineStyle(props => {
  const { colorScheme } = props

  return {
    color: `${colorScheme}.600`,
  }
})

const baseStyle = definePartsStyle(props => ({
  container: baseStyleContainer(props),
  title: baseStyleTitle(props),
  description: baseStyleDescription(props),
  icon: baseStyleIcon(props),
}))

export const Alert = defineMultiStyleConfig({
  baseStyle,
})
